import createCachedSelector from 're-reselect';

const getSlotName = (state, { name: slotName }) => slotName;
const getOutfit = ({ outfit }) => outfit;
const getQualities = ({ myself: { qualities } }) => qualities;

const cacheKey = getSlotName;

const inputs = [getOutfit, getQualities, getSlotName];

// We receive 'HomeComfort' from the qualities, but the outfit reducer
// has 'Home Comfort'
export const humanReadable = (slotName) => {
  if (slotName === 'HomeComfort') {
    return 'Home Comfort';
  }
  return slotName;
};

// Look for the quality that matches what we've got stored in the current outfit
const output = (outfit, qualities, slotName) => qualities.find(
  q => q.id === outfit[humanReadable(slotName)],
);


export default createCachedSelector(inputs, output)(cacheKey);